/**
 * Validation service for server-side validation
 * REG-002: Server-Side Validation Edge Function
 */

import { config } from '@/config/environment';

interface SignupValidationRequest {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  recaptchaToken?: string;
}

interface SignupValidationSuccess {
  success: true;
  message: string;
  data: {
    email: string;
    firstName: string;
    lastName: string;
  };
}

interface SignupValidationError {
  success: false;
  error: string;
  validationErrors: Record<string, string[]>;
}

type SignupValidationResponse = SignupValidationSuccess | SignupValidationError;

const SUPABASE_URL = config.supabase.url;
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJodmF0YnptZ25qZnZ1ZHp1Y21wIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM2NjAwNjAsImV4cCI6MjA2OTIzNjA2MH0.TAIaaxuybTbu4uwZnKXW3bO5pvuTAB_lYRkSrWLDEiM';

/**
 * Validates signup data via Edge Function
 * Returns validation result or throws on network errors
 */
export async function validateSignupData(
  data: SignupValidationRequest
): Promise<SignupValidationResponse> {
  const response = await fetch(
    `${SUPABASE_URL}/functions/v1/validate-signup`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${SUPABASE_ANON_KEY}`
      },
      body: JSON.stringify(data)
    }
  );

  if (!response.ok && response.status !== 400) {
    // Network or server errors (not validation errors)
    if (response.status === 429) {
      throw new Error('RATE_LIMIT');
    }
    throw new Error('SERVER_ERROR');
  }

  return await response.json();
}
